import React from "react";
import PlusOutlined from "@ant-design/icons/PlusOutlined";
import { SignalBotsIcon } from "common/Icons/Icons";
import Button from "common/Buttons/Button";
import styled, { css, useTheme } from "styled-components";
import { Bot, Plus } from "lucide-react";
import { appendSubGroupId, getCreateBotRoute } from "utils/routes";
import {
  BotType,
  GroupData,
  LanguageNameSpaces,
  MarketplaceSubGroup,
} from "@shared/types";
import { useHistory } from "react-router-dom";
import Tooltip from "common/Tooltips/Tooltip";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface CreateBotButtonProps {
  groupData?: GroupData | MarketplaceSubGroup;
}

const CreateBotButton = ({ groupData }: CreateBotButtonProps) => {
  const history = useHistory();
  const isMarketplaceGroup = !!groupData && "group_id" in groupData;
  const groupId = isMarketplaceGroup ? groupData?.group_id : groupData?.id;
  const { t } = useTypedTranslation(LanguageNameSpaces.GROUPS);
  const { isNewLook } = useTheme();

  const onCreateBotClick = () => {
    if (!groupId) return;
    history.push(appendSubGroupId(getCreateBotRoute(BotType.SIGNAL), groupId));
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Tooltip title={t("my_group.create_bot_button_tooltip")}>
        <StyledButton
          $type="secondary"
          onClick={(e) => {
            e.stopPropagation();
            onCreateBotClick();
          }}
        >
          {isNewLook ? <Plus size={14} strokeWidth={2} /> : <PlusOutlined />}
          {isNewLook ? (
            <Bot size={15} strokeWidth={1.75} style={{ marginLeft: 2 }} />
          ) : (
            <SignalBotsIcon style={{ marginLeft: 6 }} />
          )}
        </StyledButton>
      </Tooltip>
    </div>
  );
};

export default CreateBotButton;

const StyledButton = styled(Button)`
  padding: 4px 9px;
  display: flex;
  align-items: center;
  svg {
    font-size: 12px;
  }
  ${(p) =>
    p.theme.isNewLook &&
    css`
      height: 30px;
      padding: 0 10px;
      gap: 2px;
      color: ${p.theme.colors.primaryBlue};
    `}
`;
